<template>
  <div class="col-xs-12">
    <div class="btn-group btn-group-justified new-switch-group">
      <label class="btn-group new-switch-label pointer" v-for="(option, index) in options" :key="index" :class="[selectedValue === option.value ? 'new-switch-active':'']" :id="'opt' + option.value" :name="name">
        <input type="radio" :value="option.value" v-model="selectedValue" @click="updateValue">
        {{ option.name }}
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'input-switch',
    props: {
      value: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    methods: {
      updateValue() {
        this.$emit('input', this.selectedValue);
      },
    },
    created() {
      this.selectedValue = this.value;
    },
    data() {
      return {
        selectedValue: '',
      };
    },
    watch: {
      selectedValue(newVal) {
        this.$emit('input', newVal);
      },
    },
  };

</script>

<style scoped>
  input {
    display: none;
  }

  .new-switch-group {
    height: 34px;
    border-radius: 4px;
    border: 1px solid #20c4f4;
    margin-bottom: 15px;
  }

  .new-switch-label {
    line-height: 32px;
    height: 32px;
    font-size: 14px;
    color: #20c4f4;
    text-align: center;
    font-weight: normal;
    overflow: hidden;
    width: 100%;
  }

  .new-switch-active {
    color: white;
    background-color: #20c4f4;
  }
</style>



// WEBPACK FOOTER //
// InputSwitch.vue?50d5f0fc